export default "__VITE_ASSET__32d7d107__"